<template>
  <div class="page_socialInsurance">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic" v-if="activeName2 == '0'">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
            <el-form-item label="账户类型" size="small">
              <el-select v-model="listQuery.accountType" placeholder="" clearable size="small" style="width: 180px;" filterable>
                <el-option value="自有账户"></el-option>
                <el-option value="供应商代参"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="账户功能" size="small">
              <el-select v-model="listQuery.accountFunction" placeholder="" clearable size="small" style="width: 180px;" filterable>
                <el-option value="社保"></el-option>
                <el-option value="公积金"></el-option>
                <el-option value="社保+公积金"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="账户全称" size="small">
              <!-- <el-input v-model="listQuery.accountFullName" size="small" clearable style="width:180px"></el-input> -->
              <el-select v-model="listQuery.accountFullName" placeholder="" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in legList" :key="index" :label="item.CompanyName" :value="item.CompanyName"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <!-- <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div> -->
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
          <div>
            <el-form-item label="垫资开始时间" size="small">
              <el-input v-model="listQuery.PayrollCompany" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="垫资结束时间" size="small">
              <el-input v-model="listQuery.CardId" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>社保</el-breadcrumb-item>
          <el-breadcrumb-item>{{ activeName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="ftabs">
        <socialTab ref="child"></socialTab>
        <el-tabs v-model="activeName2" @tab-click="changeTab2">
          <el-tab-pane label="账户设置" name="0"></el-tab-pane>
          <el-tab-pane label="管理员设置" name="1"></el-tab-pane>
        </el-tabs>

        <div class="ftabBtn flex">
          <el-button type="success" size="small" @click="addAccount" v-if="activeName2 == '0' && checkPermission(['socialSet_addAccount'], this.permissionLists)">新增</el-button>
          <el-button type="success" size="small" @click="addPeople" v-if="activeName2 == '1' && checkPermission(['socialSet_addAdmin'], this.permissionLists)">新增</el-button>
          <el-button type="primary" size="small" @click="expList" v-if="activeName2 == '0' && checkPermission(['socialSet_export'], this.permissionLists)" :loading="isExping">导出</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <template v-if="activeName2 == 0">
            <el-table-column prop="accountFullName" key="1" label="账户全称" min-width="160" :show-overflow-tooltip="true" align="center" fixed="left">
            </el-table-column>
            <el-table-column prop="accountType" key="2" label="账户类型" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="accountFunction" key="3" label="账户功能" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="supplierName" key="4" label="负责人" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <span v-for="(item, index) in row.administratorInputs" :key="index">{{ item.name + ';' }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="supplierNamePhone" key="5" label="联系电话" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column> -->
            <el-table-column key="5.1" label="服务省市区" min-width="160" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>{{ row.serveProvince + '-' + row.serveCity + '-' + row.serveArea }}</template>
            </el-table-column>
            <el-table-column prop="remark" key="6" label="备注" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <!-- <el-table-column prop="name" key="7" label="创建人" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column> -->
            <el-table-column prop="createTime" key="8" label="创建时间" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>{{ row.createTime ? row.createTime.replace('T', ' ') : '' }}</template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="100" fixed="right">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" @click="edit(row)" v-if="row.isedit || roletype.indexOf('admin') != -1">编辑</el-button>
                  <el-popconfirm title="请确认是否删除" @confirm="del(row)" style="margin-left:10px;" v-if="row.isedit || roletype.indexOf('admin') != -1">
                    <el-button type="text" v-preventReClick slot="reference">删除</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-if="activeName2 == 1">
            <el-table-column prop="name" key="1" label="姓名" min-width="100" :show-overflow-tooltip="true" align="center" fixed="left">
            </el-table-column>
            <el-table-column prop="phoneNum" key="2" label="联系电话" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="remark" key="3" label="备注" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <!-- <el-table-column prop="name" key="4" label="创建人" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column> -->
            <el-table-column prop="createTime" key="5" label="创建时间" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>{{ row.createTime ? row.createTime.replace('T', ' ') : '' }}</template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="100" fixed="right">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" @click="editPeople(row)" v-if="row.userId == userId || roletype.indexOf('admin') != -1">编辑</el-button>
                  <el-popconfirm title="请确认是否删除" @confirm="del(row)" style="margin-left:10px;" v-if="row.userId == userId || roletype.indexOf('admin') != -1">
                    <el-button type="text" v-preventReClick slot="reference">删除</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </template>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog :title="type == 'add' ? '新增参保账户' : '编辑'" :visible.sync="showAddAccount" width="920px">
      <el-form :model="accountForm" :inline="true" ref="accountForm" label-width="120px" :rules="rules" size="small">
        <el-form-item label="账户类型:" prop="accountType">
          <el-select v-model="accountForm.accountType" placeholder="" clearable size="small" style="width: 300px;" filterable @change="changeAccountType">
            <el-option value="自有账户"></el-option>
            <el-option value="供应商代参"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账户功能:" prop="accountFunction">
          <el-select v-model="accountForm.accountFunction" placeholder="" clearable size="small" style="width: 300px;" filterable>
            <el-option value="社保"></el-option>
            <el-option value="公积金"></el-option>
            <el-option value="社保+公积金"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账户全称:" prop="accountFullName">
          <el-select v-model="accountForm.accountFullName" placeholder="" value-key="Projectid" size="small" style="width: 300px;" clearable filterable v-if="accountForm.accountType != '供应商代参'">
            <el-option v-for="(item, index) in legList" :key="index" :label="item.CompanyName" :value="item.CompanyName"></el-option>
          </el-select>
          <el-input v-model="accountForm.accountFullName" v-if="accountForm.accountType == '供应商代参'" size="small" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="服务省市区:" prop="serveProvince">
          <el-cascader :props="propsAddress" filterable ref="cascaderArr" clearable v-model="address" :options="areaList" @change="changeAreaHandle" size="small" style="width: 300px;"></el-cascader>
        </el-form-item>
        <el-form-item label="负责人:" prop="administratorInputs">
          <el-select v-model="responsibleId" placeholder="" size="small" style="width: 300px;" clearable filterable multiple @change="changeResponsible">
            <el-option v-for="(item, index) in responsibleList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="社保服务费:">
          <span>新缴/续缴</span>
          <el-input v-model="accountForm.newPayment" type="number" size="small" style="width: 60px;margin: 0 5px;"></el-input>
          <span>元/人 补缴</span>
          <el-input v-model="accountForm.supplementaryPayment" type="number" size="small" style="width: 60px;margin-left: 5px;"></el-input>
          <span>元/人</span>
        </el-form-item>
        <el-form-item label="公积金服务费:" v-if="accountForm.accountType == '自有账户'">
          <span>新缴/续缴</span>
          <el-input v-model="accountForm.fundPayment" type="number" size="small" style="width: 60px;margin: 0 5px;"></el-input>
          <span>元/人 补缴</span>
          <el-input v-model="accountForm.fundSupplementaryPayment" type="number" size="small" style="width: 60px;margin-left: 5px;"></el-input>
          <span>元/人</span>
        </el-form-item>
        <el-form-item label="工资服务费:">
          <el-input v-model="accountForm.salaryPayment" size="small" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="其他服务费:">
          <el-input v-model="accountForm.otherPayment" size="small" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="供应商名称:" v-if="accountForm.accountType == '供应商代参'">
          <el-input v-model="accountForm.supplierName" size="small" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="供应商联系电话:" v-if="accountForm.accountType == '供应商代参'">
          <el-input v-model="accountForm.supplierNamePhone" size="small" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="accountForm.remark" size="small" style="width: 300px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddAccount = false" size="small">取消</el-button>
        <el-button type="primary" size="small" @click="confirmAddAccount" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="type == 'add' ? '新增社保管理员' : '编辑'" :visible.sync="showAddPeople" width="500px">
      <el-form :model="formData" ref="formData" label-width="80px" :rules="rules">
        <el-form-item label="管理员:" prop="phoneNum">
          <el-select v-model="formData.phoneNum" placeholder="" value-key="Projectid" size="small" style="width: 300px;" clearable filterable @change="changePeople">
            <el-option v-for="(item, index) in customerList" :key="index" :label="item.Username" :value="item.Strmobile"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="formData.remark" size="small" style="width: 300px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddPeople = false" size="small">取消</el-button>
        <el-button type="primary" size="small" @click="confirmAddPeople" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import {
    replacer
  } from "mathjs";
  import xz from "../../common";
  import socialTab from "./components/socialTab.vue"
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    components: {
      socialTab
    },
    data() {
      return {
        listQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: [{
              property: "createTime",
              order: 1
            }]
          },
          accountType: '', //账户类型
          accountFunction: '', //账户功能
          accountFullName: '', //账户全称
          serveProvince: '',
          serveCity: '',
          serveArea: '',
          supplierName: '', //供应商名称
          insuranceType: '', //政策类型
          referenceCard: '', //参保账户
          userId: Cookies.get("userid-b"),
        },
        permissionLists: [],
        showDropScreen: -1,
        activeName: '社保设置',
        num1: 0,
        tableData: [],
        customerList: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        proNameList: [], //项目列表
        activeName2: '0',
        isExping: false,
        legList: [], //主体列表
        showAddAccount: false,
        areaList: [],
        accountForm: {
          id: '',
          accountType: '', //账户类型
          accountFunction: '', //账户功能
          accountFullName: '', //账户全称
          serveProvince: '', //服务省区
          serveCity: '', //服务市区
          serveArea: '', //服务区县
          responsibleId: '', //责任人
          remark: '', //备注
          newPayment: null, //新缴/续缴
          supplementaryPayment: null, ///补缴
          supplierName: '', //供应商名称
          supplierNamePhone: '', //供应商联系电话
          fundPayment: null, //公积金服务费  新缴/续缴
          fundSupplementaryPayment: null, //补缴
          salaryPayment: null, //工资服务费
          otherPayment: null, //其他服务费
          salarySupplementaryPayment: null, //工资补缴
          otherSupplementaryPayment: null, //其他补缴
          administratorInputs: [],
          createUserId: Cookies.get("userid-b"),
          updataUserId: Cookies.get("userid-b"),
          userId: Cookies.get("userid-b")
        },
        responsibleId: [],
        rules: {
          phoneNum: {
            required: true,
            message: '请选择管理员',
            trigger: 'change'
          },
          accountType: {
            required: true,
            message: '请选择账号类型',
            trigger: 'change'
          },
          accountFunction: {
            required: true,
            message: '请选择账号功能',
            trigger: 'change'
          },
          accountFullName: {
            required: true,
            message: '请选择账户全称',
            trigger: 'change'
          },
          serveProvince: {
            required: true,
            message: '请选择服务省市区',
            trigger: 'change'
          },
          administratorInputs: {
            required: true,
            message: '请选择负责人',
            trigger: 'change'
          },
        },
        address: [],
        isBtnLoading: false,
        propsAddress: {
          label: 'Name',
          value: 'Name',
          children: 'children',
          checkStrictly: true
        },
        responsibleList: [], //社保管理员列表
        showAddPeople: false,
        type: '',
        userId: Cookies.get("userid-b"),
        formData: {
          id: '',
          name: '',
          remark: '',
          phoneNum: '',
          createUserId: Cookies.get("userid-b"),
          updataUserId: Cookies.get("userid-b"),
          userId: Cookies.get("userid-b")
        }
      }
    },
    created() {
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.id = this.$route.query.id;
      }
      this.getButtonPower();
      this.getALLResponsible();
      this.getList();
      this.getlegalsubjectlist();
      this.getMemberList();
      this.getprovinces();
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let d = {
          path: '/socialBill',
          powerEnName: 'socialBill'
        }
        xz.getbtnPowerIdBypage(d).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let d = {
          CompanyName: "",
          BusinessUnit: "",
          HasHumanResoLicen: "",
          HasLaborlicense: "",
          BillingType: "",
          LaborlicenseUrl: "",
          RegisteredAddress: "",
          pageNum: 1,
          pageSize: 10000
        }
        xz.getlegalsubjectlist(d, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      //获取省市区
      getprovinces() {
        xz.getAreaAll().then(res => {
          this.areaList = res;
          this.addArea('陕西省', '西安市', '高新科技开发区');
          this.addArea('山东省', '济宁市', '济宁经济技术开发区');
        });
      },
      addArea(p, c, area) {
        // 找到陕西省
        const shanxiProvince = this.areaList.find(province => province.Name === p);
        if (shanxiProvince) {
          // 找到西安市
          const xianCity = shanxiProvince.children.find(city => city.Name === c);
          if (xianCity) {
            // 添加高新科技开发区
            xianCity.children.push({
              Name: area
            });
          } else {

          }
        } else {}
      },
      // 获取人员列表
      getMemberList() {
        let data = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: "",
        }
        xz.getauthUserInfoByorgancode(data).then((res) => {
          if (res.status == "ok") {
            this.customerList = res.msg;
          } else {
            this.customerList = [];
          }
        });
      },
      resetHandle() {
        this.listQuery = this.$options.data.call(this).listQuery;
      },
      currentChange(val) {
        this.listQuery.PageModel.Page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.PageModel.Page = 1;
        this.listQuery.PageModel.Rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.getList();
      },
      getList() {
        let pagename = this.activeName2 == '0' ? 'GetSocialSettingsPageList' : 'GetSocialAdministratorPageList';
        this.loading = true;
        xz.SocialFun(this.listQuery, pagename, 'post').then(res => {
          if (res.status == 'ok') {
            if (this.activeName2 == '0') {}
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      //获取社保管理员列表
      getALLResponsible() {
        let d = {
          PageModel: {
            Rows: 100000,
            Page: 1,
            OrderInput: []
          }
        }
        xz.SocialFun(d, 'GetSocialAdministratorPageList', 'post').then(res => {
          if (res.status == 'ok') {
            this.responsibleList = res.data.data;
          } else {
            this.responsibleList = [];
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab() {
        if (this.activeName == '垫资成本') {
          this.$router.push({
            path: '/advCost'
          })
        }
      },
      changeTab2() {
        if (this.activeName2 == '0') {
          this.listQuery = {
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: [{
                property: "createTime",
                order: 0
              }]
            },
            accountType: '', //账户类型
            accountFunction: '', //账户功能
            accountFullName: '', //账户全称
            serveProvince: '',
            serveCity: '',
            serveArea: '',
            supplierName: '', //供应商名称
            insuranceType: '', //政策类型
            referenceCard: '', //参保账户
            userId: Cookies.get("userid-b"),
          }
        } else {
          this.listQuery = {
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: [{
                property: "createTime",
                order: 0
              }]
            }
          }
        }
        this.getList();
      },
      //新增设置
      addAccount() {
        this.type = 'add';
        this.accountForm = this.$options.data.call(this).accountForm;
        this.address = [];
        this.responsibleId = [];
        this.showAddAccount = true;
      },
      edit(row) {
        this.type = 'edit';
        this.accountForm = JSON.parse(JSON.stringify(row));
        this.accountForm.userId = Cookies.get("userid-b")
        if (row.serveProvince && row.serveCity && row.serveArea) {
          this.address = [row.serveProvince, row.serveCity, row.serveArea]
        }
        this.responsibleId = [];
        if (row.administratorInputs.length > 0) {
          row.administratorInputs.forEach(e => {
            this.responsibleId.push(e.id)
          });
        }
        this.showAddAccount = true;
      },
      changeResponsible(val) {
        if (this.responsibleId.length > 0) {
          this.accountForm.administratorInputs = [];
          this.responsibleId.forEach(e => {
            let d = {
              id: '',
              remark: '',
              socialAdministratorId: e,
              createUserId: Cookies.get("userid-b"),
              updataUserId: Cookies.get("userid-b"),
              socialSettingsId: ''
            }
            this.accountForm.administratorInputs.push(d)
          });
        }
      },
      changeAccountType() {
        this.accountForm.supplierName = '';
        this.accountForm.supplierNamePhone = '';
        this.accountForm.fundPayment = null;
        this.accountForm.fundSupplementaryPayment = null;
      },
      changeAreaHandle(val) {
        // 确保 val 是一个数组
        if (!Array.isArray(val)) {
          console.error('Invalid input: val must be an array');
          return;
        }
        // 确保 accountForm 存在且是一个对象
        if (!this.accountForm || typeof this.accountForm !== 'object') {
          console.error('accountForm is not properly initialized');
          return;
        }
        this.accountForm.serveProvince = '';
        this.accountForm.serveCity = '';
        this.accountForm.serveArea = '';
        // 定义字段映射关系
        const fieldMapping = ['serveProvince', 'serveCity', 'serveArea'];
        // 遍历 val 并赋值
        val.forEach((item, index) => {
          if (index < fieldMapping.length) {
            this.accountForm[fieldMapping[index]] = item;
          }
        });
      },
      confirmAddAccount() {
        this.$refs.accountForm.validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            if (this.responsibleId.length > 0) {
              this.accountForm.administratorInputs = [];
              this.responsibleId.forEach(e => {
                let d = {
                  id: '',
                  remark: '',
                  socialAdministratorId: e,
                  createUserId: Cookies.get("userid-b"),
                  updataUserId: Cookies.get("userid-b"),
                  socialSettingsId: ''
                }
                this.accountForm.administratorInputs.push(d)
              });
              // 去重操作
              const uniqueInputs = Array.from(new Set(this.accountForm.administratorInputs.map(item => JSON.stringify(item))));
              this.accountForm.administratorInputs = uniqueInputs.map(item => JSON.parse(item));
            }
            xz.SocialFun(this.accountForm, 'CreateOrEditSocialSettings', 'post').then(res => {
              if (res.status == 'ok') {
                this.getList();
                this.isBtnLoading = false;
                this.showAddAccount = false;
                this.$message.success('保存成功');
              } else {
                this.isBtnLoading = false;
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      //新增管理员
      addPeople() {
        this.type = 'add';
        this.formData = this.$options.data.call(this).formData;
        console.log(this.formData)
        this.showAddPeople = true;
      },
      editPeople(row) {
        this.type = 'eidt';
        this.formData = JSON.parse(JSON.stringify(row));
        this.formData.userId = Cookies.get("userid-b")
        this.showAddPeople = true;
      },
      changePeople(val) {
        console.log(val)
        let item = this.customerList.find(e => e.Strmobile == val)
        this.formData.name = item.Username
      },
      confirmAddPeople() {
        this.$refs.formData.validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.SocialFun(this.formData, 'CreateOrEditSocialAdministrator', 'post').then(res => {
              if (res.status == 'ok') {
                this.getList();
                this.getALLResponsible();
                this.isBtnLoading = false;
                this.showAddPeople = false;
                this.$message.success('保存成功');
              } else {
                this.isBtnLoading = false;
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      //删除
      del(row) {
        let pagename = this.activeName2 == '0' ? 'DeleteSocialSettings' : 'DeleteSocialAdministrator';
        let d = {
          id: [row.id],
          userId: Cookies.get("userid-b")
        }
        this.loading = true;
        xz.SocialFun(d, pagename, 'DELETE').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.getALLResponsible();
            this.isBtnLoading = false;
            this.showAddPeople = false;
            this.$message.success('保存成功');
          } else {
            this.isBtnLoading = false;
            this.$message.error(res.msg);
          }
        })
      },
      //导出
      expList() {
        this.isExping = true;
        let d = JSON.parse(JSON.stringify(this.listQuery));
        delete d.PageModel;
        xz.SocialExpFun(d, 'ExportSocialSettingsPageList').then(res => {
          if (res) {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = `${this.activeName}列表.xlsx`;
              anchor.click();
              window.URL.revokeObjectURL(data);
              this.isExping = false;
            } catch (e) {
              this.isExping = false;
              this.$message.error('导出异常')
            }
          } else {
            this.$message.error('导出失败');
            this.getList();
            this.isExping = false;
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .record {
    margin-top: 10px;
    color: #797979;
  }

  .checkedgroup {
    display: flex;
    /* flex-flow: wrap; */
  }

  .pro_down_box {
    padding-left: 29px;
  }
</style>
<style>
  .page_socialInsurance .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_socialInsurance .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_socialInsurance .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_socialInsurance .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_socialInsurance .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_socialInsurance .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_socialInsurance .checkedgroup .el-checkbox {
    margin-right: 10px;
  }

  .page_socialInsurance .el-checkbox__label {
    padding-left: 3px;
  }

  .page_socialInsurance .checkedgroup2 .el-checkbox {
    margin-bottom: 5px;
  }
</style>